import { css } from 'emotion';

export const backgroundStyle = (imgUrl) => css`
& {
  display: contents;

  > .background {
    width: 100%;
    height: 30vh;
    background-image: url(${imgUrl});
    margin-top: calc((var(--f7-page-navbar-offset, 0px) + var(--f7-page-toolbar-top-offset, 0px) + var(--f7-page-subnavbar-offset, 0px) + var(--f7-page-searchbar-offset, 0px) + var(--f7-page-content-extra-padding-top, 0px)) * -1);
  
    background-position: center;
    background-repeat: no-repeat;    
  }  

  .region-title {
    padding-top: calc(var(--f7-page-navbar-offset,0px) + var(--f7-page-toolbar-top-offset,0px) + var(--f7-page-subnavbar-offset,0px) + var(--f7-page-searchbar-offset,0px) + var(--f7-page-content-extra-padding-top,0px) + 20px);
    color: #fff;
    background-color: rgba(0, 0, 0, 0.4);
    display: inline-block;
    font-weight: normal;
    font-size: 22px;
    width: 100%;
    height: 100%;
    margin: 0;
    padding-left: 5vw;
    box-sizing: border-box;
  }  

  .hide {
    display: none !important;
  }

  .more {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    border-radius: 5px;
    transition: all 500ms ease;
  }

  .more:hover {
    animation: more 500ms ease;
  }

  .tab-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2b2b;
    display: flex;
    align-items: center;
    position: relative;
    margin-top: 20px;
    margin-bottom: 0;
  }

  .tab-title::before {
    content: 'INFO';
    position: absolute;    
    top: -23px;
    left: 6px;
    opacity: 0.15;
    font-family: Raanana;
    font-size: 33px;
    font-weight: bold;      
    color: #646464;
  }

  .tab-title.rest-area::before {
    content: 'Rest Areas';
  }

  .tab-title.region::before {
    content: 'Region';
  }

  .tab {
    padding: 0 5vw;
    background-color: #fcfcfc;
    padding-top: 30px;
    padding-bottom: 20px;
  }

  #map {
    width: 100%;
    height: 200px;
    background-color: rgba(0, 0, 0, 0.1);
    pointer-events: none;
  }

  .rest-area-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .rest-area-card {
    max-height: 80px;
  }

  .rest-area-card,
  .region-card {
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;  
    
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  icon-location {
    width: 30px;
    height: 30px;
  }
}

@keyframes more {
  0% {
    background-color: transparent;
  }

  50% {
    background-color: rgba(0, 0, 0, 0.1);
  }

  100% {
    background-color: transparent;
  }
}
`;

export const cardStyle = (imgUrl) => css`
& {

  &.region-card {
    max-height: 240px;
  }

  &:hover {
    animation: scaleup 300ms ease;
  }

  .img {
    width: 100%;
    height: 140px;
    background-image: url(${imgUrl});
    background-position: center;
    background-repeat: no-repeat;    
    background-size: cover;
    overflow: hidden;
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 10px;
  }

  h3 {
    margin: 10px;
    margin-bottom: 0;
    font-size: 18px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  h4 {
    margin: 10px;
    margin-top: 0;
    font-size: 12px;
    font-weight: 300;
    color: #333;
  }

  &.region-card h4 {
    white-space: normal;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    max-height: 3.6rem;
  }

  icon-star {
    display: inline-block;
    width: 20px;
    height: 20px;
  }

  .score-wrap {
    display: flex;
    align-items: center;
  }
}

@keyframes scaleup {
  0% { transform: scale(1.00); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1.00); }
}
`;